export function articleDetail(state: object = {fetching: false, entities: {}, error: ''}, action: any) {
    switch (action.type) {
        case 'ARTICLE_DETAIL':
            return {...state, fetching: action.data}

        case 'ARTICLE_DETAIL_SUCCESS':
            return {...state, entities: action.data}

        case 'ARTICLE_DETAIL_ERROR':
            return {...state, error: action.data}

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/scenes/ArticleDetail/reducers.tsx